import { genreOptions, regionOptions, yearOptions } from "@/mocks/categories";

interface FilterProps {
  genre: string[];
  region: string[];
  year: string[];
  onGenre: (v: string[]) => void;
  onRegion: (v: string[]) => void;
  onYear: (v: string[]) => void;
  onReset: () => void;
  activeCount: number;
}

function toggle(list: string[], value: string): string[] {
  return list.includes(value) ? list.filter((v) => v !== value) : [...list, value];
}

export default function CategoryFilterBar({
  genre,
  region,
  year,
  onGenre,
  onRegion,
  onYear,
  onReset,
  activeCount,
}: FilterProps) {
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground-950">筛选条件</h3>
        {activeCount > 0 && (
          <button
            type="button"
            onClick={onReset}
            className="text-xs text-accent-700 hover:text-accent-900 transition-colors cursor-pointer"
          >
            重置
          </button>
        )}
      </div>

      <FilterGroup title="影片类型" options={genreOptions} selected={genre} onToggle={(v) => onGenre(toggle(genre, v))} />
      <FilterGroup title="地区" options={regionOptions} selected={region} onToggle={(v) => onRegion(toggle(region, v))} />
      <FilterGroup title="年份" options={yearOptions} selected={year} onToggle={(v) => onYear(toggle(year, v))} />
    </div>
  );
}

function FilterGroup({
  title,
  options,
  selected,
  onToggle,
}: {
  title: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
}) {
  return (
    <div>
      <p className="mb-2.5 text-sm font-medium text-foreground-800">{title}</p>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = selected.includes(option);
          return (
            <button
              key={option}
              type="button"
              onClick={() => onToggle(option)}
              className={`rounded-md px-2.5 py-1.5 text-xs transition-colors cursor-pointer ${
                active
                  ? "bg-accent-500 text-background-50"
                  : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}